import { render, staticRenderFns } from "./ListingRelatedProperties.vue?vue&type=template&id=ad36cc00&"
import script from "./ListingRelatedProperties.vue?vue&type=script&lang=js&"
export * from "./ListingRelatedProperties.vue?vue&type=script&lang=js&"
import style0 from "./ListingRelatedProperties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports